{#if isVisible}
  <div
    class="ne-message-modal"
    transition:fade="{{duration: 200}}">
    <div class="ne-message-modal-inner">
      <div class="ne-overlay" role="button" on:click="{toggleMessageModal}"></div>
      <slot></slot>
    </div>
  </div>
{/if}

<style>
  .ne-message-modal {
    box-sizing: border-box;
  }

  .ne-message-modal :global(*),
  .ne-message-modal :global(*):before,
  .ne-message-modal :global(*):after {
    box-sizing: inherit;
  }

  .ne-overlay {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 0;
  }

  .ne-message-modal {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1;
  }

  .ne-message-modal-inner {
    display: grid;
    height: 100%;
    max-height: 100%;

    grid-template-columns: auto;
    grid-template-rows: auto;

    -ms-grid-columns: 1fr;
    -ms-grid-rows: 1fr;
  }
</style>

<script>
  import { fade } from 'svelte-transitions';
  import { store } from '../stores';
  export let isVisible;
  export let toggleMessageModal;
</script>
